import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PublicNav from './PublicNav';

// Layout route for every public (signed-out) surface. Mounts the single
// fixed bottom tab bar once, above whatever page the router resolves —
// pages themselves never render navigation. Hosts reserve the bar's 60px
// height with bottom padding (PublicPageLayout / MarketingHero).
//
// React Router does not reset scroll on navigation; the long content pages
// (FAQ, legal) would otherwise open mid-scroll after browsing another page.
const PublicShell = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Outlet />
      <PublicNav />
    </>
  );
};

export default PublicShell;
